module.exports = __webpack_public_path__ + "static/media/Luis_Rangel-Resume.a35952bc.pdf";